
  import {Component, Prop, Watch, Vue} from "vue-property-decorator";
  import { Alert } from "@/addons/Alert";
  import { useConsultorioStore } from '../../store/consultorioStore';
  import { globalStore } from '../../store/globalStore';
  import { consultorioService } from '../../services/ConsultorioService';
  
  @Component({
    name: "FormEspecialidad"
  })
  export default class FormEspecialidad extends Vue {
    @Prop() dialog!: boolean
    @Prop() resina!: object
    @Prop() esmaltes!: any
    @Prop() dentinas!: any
    @Prop() translucidas!: any
    @Prop() opacos!: any

    private globalStore = globalStore();
    private consultorioStore = useConsultorioStore();
    private consultorioService = consultorioService.getInstance();
  
    resinaForm = {
      id: null,
      resina: '',
      industria: '',
    };
    componente = {
      id: null,
      codigo: '',
    }
    valid = true;
    editar = 0;
    swComponente = false;
    swNuevo = false;
    codigo = '';
    posicion = 'Anterior';
    tipo = ''
    swEsmalte = false;
    swDentina = false;
    swTranslucida = false;
    swOpaco = false;
    mounted(){
      setTimeout(this.cargarDatos,1500);
    }
    
    close(){
      this.limpiar();
      this.$emit("listar");
      this.$emit("close");
    }
    edit(componente:any){
      this.swNuevo = false;
      this.swComponente = true;
      this.codigo = componente.codigo;
      this.posicion = componente.posicion;
      this.editar = componente.id;
      this.tipo = componente.tipo;
    }
    guardar(){
      if (!this.$refs.form.validate()) {
        Alert.warning( `Llene todos los campos obligatorios (*)`)
          return;
        }
      
        Alert.confirm(`Se realizará la modificacion de la resina (nombre y/o industria)`, 'Modificar resina?').then(async result => {
          if(result.isConfirmed){
            await this.consultorioService.updateResina(this.resinaForm)
            this.limpiar()
            this.$emit('close')
            this.$emit('listar')
          }
        })
  
      
    }
    cargarDatos(){
      this.resinaForm.id = this.resina.id;
      this.resinaForm.resina = this.resina.resina;
      this.resinaForm.industria = this.resina.industria;
      
    }
    limpiar(){
      this.resinaForm = {
        id: null,
        resina: '',
        industria: '',
      };
    }
    nuevaFila(tipo:string){ 
      this.swComponente = true;
      this.tipo = tipo;
      this.codigo = '';
      this.swNuevo = true;
    }
    async agregar() {
      const form = {
        resina_id: this.resinaForm.id,
        codigo: this.codigo,
        tipo: this.tipo,
        posicion: this.posicion
      }
      await this.consultorioService.nuevoComponente(form).then(response => {
        this.codigo = '';
        this.swComponente = false;
        this.swNuevo = false;
        switch (this.tipo) {
          case 'ESMALTE':
            this.esmaltes = response.componentes
            break;
          case 'DENTINA':
            this.dentinas = response.componentes
            break;
          case 'ZONA TRANSLUCIDA':
            this.translucidas = response.componentes
            break;
          case 'OPACO':
            this.opacos = response.componentes
            break;
          default:
            break;
        }
      })
    }
    async actualizar() {
      const form = {
        id: this.editar,
        codigo: this.codigo,
        tipo: this.tipo,
        posicion: this.posicion,
        resina_id: this.resinaForm.id
      }
      await this.consultorioService.updateComponenteResina(form).then(response => {
        this.editar = 0;
        this.codigo = ''
        this.swComponente = false;
        switch (this.tipo) {
          case 'ESMALTE':
            this.esmaltes = response.componentes
            break;
          case 'DENTINA':
            this.dentinas = response.componentes
            break;
          case 'ZONA TRANSLUCIDA':
            this.translucidas = response.componentes
            break;
          case 'OPACO':
            this.opacos = response.componentes
            break;
          default:
            break;
        }
      })
    }
    get loading(): boolean {
      return this.consultorioStore.loading;
    }
    
  }
  